import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LanguageRepository } from "./language.repository";

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [LanguageRepository],
})
export class LanguageDomainModule {}
